import Router from './Router'

import HeaderController from './components/Header/HeaderController';

function App() {
  return (
    <>
      <Router />
    </>
  );
}

export default App;
